import { Component, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { FsDialogModule } from '@firestitch/dialog';

import { AppService } from '@app/core';


@Component({
  selector: 'app-help-dialog',
  standalone: true,
  imports: [
    FsDialogModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './help-dialog.component.html',
  styleUrl: './help-dialog.component.scss',
})
export class HelpDialogComponent {
  private _appService = inject(AppService);


  public openParentSupport() {
    const parentSupportUrl = this._appService.settings.helpParentUrl;
    window.open(parentSupportUrl, '_blank');
  }

  public openOrgSupport() {
    const orgSupportUrl = this._appService.settings.helpOrganizationUrl;
    window.open(orgSupportUrl, '_blank');
  }

}
